// extracted by mini-css-extract-plugin
export default {"thumb":"base-fill-type-options-module__thumb--aUEr3"};